import { connect } from 'react-redux';
import { getAdminText200 } from 'services/themes';
import FancyButton from './FancyButton';

const mapStateToProps = state => ({
  adminText200: getAdminText200(state),
});

export default connect(mapStateToProps)(FancyButton);
